import React, { useState } from 'react';
import './EndpointsSettings.css'
import { Back } from '../../../../../../../components/back/Back';

const EndpointsSettings = ({ serviceName, setEndpoints, next, back, data }) => {
    const [endpoints, setEndpointsData] = useState(data);
    const [expandedEndpoints, setExpandedEndpoints] = useState([]);

    const addEndpoint = (e) => {
        e.preventDefault();
        setEndpointsData([...endpoints, {
            endpoint_type: "RestApi",
            name: "hello",
            path: "/hello",
            method: "GET",
            variables: []
        }]);
        setExpandedEndpoints([...expandedEndpoints, false])
    };

    const removeEndpoint = (e, endpointIndex) => {
        e.preventDefault();
        setEndpointsData(endpoints.filter((_, index) => index !== endpointIndex));
        setExpandedEndpoints(expandedEndpoints.filter((_, index) => index !== endpointIndex))
    }

    const toggleExpandEndpoint = (e, endpointIndex) => {
        e.preventDefault();
        var updated = [...expandedEndpoints]
        updated[endpointIndex] = !updated[endpointIndex]
        setExpandedEndpoints(updated)
    }

    const addEndpointVar = (e, endpointIndex) => {
        e.preventDefault();
        const updatedEndpoints = [...endpoints];
        updatedEndpoints[endpointIndex].variables.push({
            name: "name",
            type: "string",
            optional: true
        });
        setEndpointsData(updatedEndpoints);
    };

    const editEndpointVar = (e, endpointIndex, variableIndex, key, value) => {
        e.preventDefault();
        const updatedEndpoints = [...endpoints];
        updatedEndpoints[endpointIndex].variables[variableIndex][key] = value
        setEndpointsData(updatedEndpoints);
    }

    const removeEndpointVar = (e, endpointIndex, variableIndex) => {
        e.preventDefault();
        const updatedEndpoints = [...endpoints];
        updatedEndpoints[endpointIndex].variables = updatedEndpoints[endpointIndex].variables.filter((_, index) => index !== variableIndex);
        setEndpointsData(updatedEndpoints);
    };

    return (
        <div className='endpoint-settings'>
            <Back back={() => {setEndpoints(endpoints); back()}}/>
            <h1>Endpoints Settings</h1>
            <button className='new-endpoint' onClick={addEndpoint}>+ New Endpoint</button>
            <div className='main-data scrollable'>
                {
                    endpoints.map((endpoint, endpointIndex) => {
                        return <div className='endpoint-container-full'>
                            <div className='endpoint-container'>
                                    <input className='path' 
                                        value={endpoint.path} onChange={(e)=>{
                                        var updatedEndpoints = [...endpoints]
                                        var newValue = e.target.value
                                        if (!newValue.startsWith("/")) {
                                            newValue = `/${newValue}`
                                        }
                                        updatedEndpoints[endpointIndex].path = newValue
                                        updatedEndpoints[endpointIndex].name = e.target.value.slice(1);
                                        setEndpoints(updatedEndpoints)
                                    }}/>
                                    <select className='method'
                                        onChange={(e) => {
                                            const updatedEndpoints = [...endpoints];
                                            updatedEndpoints[endpointIndex].method = e.target.value;
                                            setEndpointsData(updatedEndpoints);
                                        }}
                                        value={endpoint.method}
                                    >
                                        <option value="GET">GET</option>
                                        <option value="POST">POST</option>
                                        <option value="PUT">PUT</option>
                                        <option value="DELETE">DELETE</option>
                                    </select>
                                    <button className='delete' onClick={(e)=>removeEndpoint(e, endpointIndex)}>X</button>
                                    <button onClick={(e)=>toggleExpandEndpoint(e, endpointIndex)} className="expand-endpoint" >{expandedEndpoints[endpointIndex] ? "v": ">"}</button>
                                </div>
                                {expandedEndpoints[endpointIndex] && <div className='vars-container'>
                                    <button onClick={(e)=>addEndpointVar(e, endpointIndex)} className='new-var'>+ new var</button>
                                    {endpoints[endpointIndex].variables.map((variable, variableIndex) => {return <div className='var-container'>
                                            {/* <label>name:</label> */}
                                            <input value={variable.name} onChange={(e) => editEndpointVar(e, endpointIndex, variableIndex, "name", e.target.value)}/>
                                            {/* <label>type:</label> */}
                                            <select value={variable.type} onChange={(e) => editEndpointVar(e, endpointIndex, variableIndex, "type", e.target.value)}>
                                                <option value="string">String</option>
                                                <option value="int">Int</option>
                                            </select>
                                            <button className='delete' onClick={(e)=> removeEndpointVar(e,endpointIndex, variableIndex)}>X</button>
                                    </div>})}
                                </div>}
                        </div>
                    })
                }
            </div>
        <button className='next-button' onClick={()=>{setEndpoints(endpoints); next()}}>next</button>
        </div>
    );
};

export default EndpointsSettings;